(ns ballot-scout-v2-frontend.layout.sidebar.views.partner-switcher
  (:require
   [ballot-scout-v2-frontend.components.click-outside :refer [click-outside]]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.layout.sidebar.views.jurisdiction-switcher :as jurisdiction-switcher]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn partner-link [partner]
  (let [valid-jurisdiction (some #(when (jurisdiction-switcher/valid-jurisdiction? %) %)
                                 (:partner/jurisdictions partner))
        current-partner @(rf/subscribe [::subs/current-partner])]
    [link
     {:route-name :ballot-scout-v2-frontend.routes/jurisdiction-home
      :params {:partner-slug (:partner/slug partner)
               :jurisdiction-slug (:jurisdiction/slug valid-jurisdiction)
               :election-slug (jurisdiction-switcher/election-slug-from-j valid-jurisdiction)}}
     (if (= (:partner/id current-partner) (:partner/id partner))
       [:tr.navbar-item.selected
        [:td [icon ::icon/check {:class "is-hidden-mobile"}]]
        [:td (:partner/name partner)]]
       [:tr.navbar-item [:td] [:td (:partner/name partner)]])]))

(defn valid-partner?
  "Partner is valid if it has a slug and has a jurisdiction current election with a slug"
  [p]
  (and (:partner/slug p)
       (some jurisdiction-switcher/valid-jurisdiction? (:partner/jurisdictions p))))

#_:clj-kondo/ignore
(defn dropdown [current-partner partners]
  (let [active? (r/atom false)]
    (fn [current-partner partners]
      [click-outside
       {:on-click-outside #(reset! active? false)}
       (fn [ref]
         [:a {:ref ref :on-click #(swap! active? not)}
          [:div.switcher.navbar-item.has-dropdown {:class (when @active? "is-active")}
           [:div.dropdown-text
            [:div.text (:partner/name current-partner)]
            (if @active? [icon ::icon/chevron-up] [icon ::icon/chevron-down])]
           (when @active?
             [:div.navbar-dropdown
              (into [:table]
                    (for [p partners]
                      ^{:key (str (:partner/slug p) "_link")} [partner-link p]))])]])])))

(defn component []
  (let [partners (->> @(rf/subscribe [::subs/all-partners])
                      (filter valid-partner?)
                      (sort-by :partner/name))
        current-partner @(rf/subscribe [::subs/current-partner])]
    (if (empty? partners)
      [:small.switcher.dropdown-text [:div.text "Loading..."]]
      [dropdown current-partner partners])))
